import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBCard, MDBCardBody, MDBAnimation } from "mdbreact";

import TableLoading from "../../../../../components/tableLoading";
import Header from "./header";
import Body from "./body";
import Footer from "./footer";
import Modal from "./modal";
import { BROWSE as BROWSE_CLINICS } from "../../../../../services/redux/slices/diagnostics/clinic/clinicInfo";

export default function Menus() {
  const { isLoading } = useSelector(({ clinicMenus }) => clinicMenus);
  const { token, activePlatform } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();

  React.useEffect(() => {
    const branchId = activePlatform?.branchId || activePlatform?.branch?._id;

    if (!token || !branchId) return;

    dispatch(
      BROWSE_CLINICS({
        token,
        params: { branchId },
      })
    );
  }, [dispatch, token, activePlatform]);

  return (
    <MDBAnimation type="bounceInDown">
      <MDBCard narrow className="pb-3" style={{ minHeight: "600px" }}>
        <Header />
        <MDBCardBody>{isLoading ? <TableLoading /> : <Body />}</MDBCardBody>
        <Footer />
        <Modal />
      </MDBCard>
    </MDBAnimation>
  );
}
